import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const comparisonSemanticSearchSchema = z.object({
  selectedId: z.string().optional().catch(undefined),
  view: z.enum(['item', 'comments']).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/comparison/$comparisonId/semantic'
)({
  validateSearch: (raw) => comparisonSemanticSearchSchema.parse(raw),
})
